import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const billingPlan = lazyWithRetry(() => import("./routes/plan"));
const billingInvoices = lazyWithRetry(() => import("./routes/invoices/index"));
const billingInvoicesDetail = lazyWithRetry(
  () => import("./routes/invoices/[id]"),
);
const billingSubscriptions = lazyWithRetry(
  () => import("./routes/subscriptions/index"),
);
const billingSubscriptionDetail = lazyWithRetry(
  () => import("./routes/subscriptions/[id]"),
);
const billingUsage = lazyWithRetry(() => import("./routes/usage/index"));
const billingReports = lazyWithRetry(() => import("./routes/reports/index"));

const billingPlanRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing/plan",
  component: () =>
    renderProtectedRoute(billingPlan, { requirePerms: ["billing:read"] }),
});

const billingInvoicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing/invoices",
  component: () =>
    renderProtectedRoute(billingInvoices, { requirePerms: ["billing:read"] }),
});

const billingInvoiceDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing/invoices/$id",
  component: () =>
    renderProtectedRoute(billingInvoicesDetail, {
      requirePerms: ["billing:read"],
    }),
});

const billingSubscriptionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing/subscriptions",
  component: () =>
    renderProtectedRoute(billingSubscriptions, {
      requirePerms: ["billing:read"],
    }),
});

const billingSubscriptionDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing/subscriptions/$id",
  component: () =>
    renderProtectedRoute(billingSubscriptionDetail, {
      requirePerms: ["billing:read"],
    }),
});

const billingUsageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing/usage",
  component: () =>
    renderProtectedRoute(billingUsage, { requirePerms: ["billing:read"] }),
});

const billingReportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing/reports",
  component: () =>
    renderProtectedRoute(billingReports, { requirePerms: ["billing:read"] }),
});

const billingIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/billing",
  component: () =>
    renderProtectedRoute(billingPlan, { requirePerms: ["billing:read"] }),
});

export const billingRouteTree = [
  billingPlanRoute,
  billingInvoicesRoute,
  billingInvoiceDetailRoute,
  billingSubscriptionsRoute,
  billingSubscriptionDetailRoute,
  billingUsageRoute,
  billingReportsRoute,
  billingIndexRoute,
];
